export default __webpack_public_path__ + "static/media/acms-recruit.d0d9bf1c.svg";